import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69c9730dc3f84800139df2b1/ovationprograms/src/app/sign-up-login-screen/components/AuthClient.tsx");
